  /** 28-06-2024 new-setup start***/
$(document).ready(function(){

// $('.product-image-main').click(function(){
//     $('.product-image-main').removeClass('active');
//     $(this).addClass('active');
//     var srcc = $(this).find('.jtpl-new-pdp-img').attr('src');
//     var srcsett = $(this).find('.jtpl-new-pdp-img').attr('srcset');
//     $('.product-image-main:first').find('.jtpl-new-pdp-img').attr('src',srcc);
//     $('.product-image-main:first').find('.jtpl-new-pdp-img').attr('srcset',srcsett);
// });
$('.product-image-main').eq(1).addClass('active');
$('.product-image-main').click(function(){
    $('.product-image-main').removeClass('active');
    $(this).addClass('active');
    var srcc = $(this).html();
   
    $('.product-image-main:first').html(srcc);
   
});
  
    // var maxWords = 38; 
    // var fullText = $(".prod_desc").text(); 

   
    // var words = fullText.split(" ");

    // if (words.length > maxWords) {
     
    //     var truncatedText = words.slice(0, maxWords).join(" ") + '...';
    //     $(".prod_desc").text(truncatedText);
    //     $(".show-more").show(); 
    // } else {
    //     $(".show-more").hide(); 
    // }

    // $(".show-more").click(function() {
    //     var button = $(this);
        
     
    //     if (button.text() === "Show More") {
    //         $(".prod_desc").text(fullText); 
    //         button.text("Show Less"); 
    //     } 
    //     // If text is full, truncate the text again and change the button to "Show More"
    //     else {
    //         var truncatedText = words.slice(0, maxWords).join(" ") + '...';
    //         $(".prod_desc").text(truncatedText); // Update the text to show truncated version
    //         button.text("Show More"); // Change button text back to "Show More"
    //     }
    // });



  $(document).on("click","h3.meta-product--heading.jtpl-meta-colap-heading",function(){
      $(this).toggleClass('active');
      $('.meta-product-wrapper.jtpl-meta-colap-content').toggle();        
});

$('.mb-photo').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  autoplay: false,
  autoplaySpeed: 3000

});

   /***** add-additional-product-js ****/
  $(document).on("click",".cstm-add-quantity",function(){
    var quan_val = $(this).find('.js-qty__num').val(); 
     var pro_id = $(this).attr('data-pro-id')
   $('.cstm-add-product-quantity[item_id="'+pro_id+'"]').attr('value', quan_val)
});
  
  /***** accordian-tab ****/
  // $('.jtpl_vactor_tabs_heading').addClass('active');
  // $('.jtpl_vactor_tabs_content').show();
  $(document).on("click",".jtpl_vactor_tabs_heading",function(){
      $(this).toggleClass('active');
      $(this).siblings('.jtpl_vactor_tabs_content').toggle();        
});
  
/***** benefit-tab ****/
$('.tabs-stage div').hide();
$('.tabs-stage div:first').show();
$('.tabs-nav li:first').addClass('tab-active');

   $(document).on("click",".tabs-nav a",function(event){
  event.preventDefault();
  $('.tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.tabs-stage div').hide();
  $($(this).attr('href')).show();
});

  
//  $(document).on("click",".meta-product-wrapper",function(){
//    $('.meta-product-wrapper').removeClass('selected');
//   var pro_url = $(this).attr('pro-url');
//  $.ajax({
//      url:pro_url + "?view=PDP_new_v10"  ,
//    type:'GET',
//    success: function(data){
//      $('.product-single__sticky').html($(data).find(".product-single__sticky").html());
//      $('.product-single__title').html($(data).find(".product-single__title").html());
//       $('.price-container').html($(data).find(".price-container").html());
//      // $('p.affirm-as-low-as').html($(data).find('p.affirm-as-low-as').html());
//      $('.tabs').html($(data).find(".tabs").html());
//      // $('.vector-includes-data').html($(data).find(".vector-includes-data").html());
     
//      // $(".page-content.page-content--product").html($(data).find(".page-content.page-content--product").html());
//      $('.meta-product-wrapper').removeClass('selected');
//      $('#tab-2').hide();
//      $('.meta-product-wrapper[pro-url="'+pro_url+'"]').addClass('selected');
//      $('.tabs-nav li:first').addClass('tab-active');
//        }
// });
// });

  $('.meta-product-wrapper').click(function(){

       $('.meta-product-wrapper').removeClass('selected');
    $(this).addClass('selected')
    var pro_amount = $(this).attr('pro-ammount');
   var pro_metaf_data =  $('.vactor-tabs-main').html();   
    var pro_id = $(this).attr('pro-id');
    var pro_title = $(this).attr('pro-title');
    var pro_img = $(this).attr('pro-all-images');
    var pro_price = $(this).attr('pro-price');
    var pro_dec = $(this).attr('pro-desc');
    var collapsible_heading = $(this).attr('pro_metal_heading');
   var collapsible_content = $(this).attr('pro_meta1_collapsible_val')
    var pro_variant_id = $(this).attr('pro-variant-id').trim();
     var image1 = $(this).attr('pro-images1');
     var image2 = $(this).attr('pro-images2');
     var image3 = $(this).attr('pro-images3');
     var image4 = $(this).attr('pro-images4');
     var image5 = $(this).attr('pro-images5');
     var image6 = $(this).attr('pro-images6');
    var video1 = $(this).find('.custom_video_to_show source').attr('src');
    var poster = $(this).find('.custom_video_to_show source').attr('poster');
    var Benefits = $(this).attr('pro-benfits');
    var addonProduct = $(this).attr('pro-meta-val');
 $('p.affirm-as-low-as').attr('data-amount',pro_amount);
    affirm.ui.refresh();
    
    $('.jtpl_vactor_tabs_heading1').html(collapsible_heading);
    $('.jtpl_vactor_tabs_content1').html(collapsible_content);
     $('.vactor_tabs_content.jtpl_vactor_tabs_content2').html(addonProduct);
    console.log(video1);
     $('video.product__video').attr('src',video1);
     $('video.product__video source').attr('src',video1);
    $('video.product__video source').attr('poster',poster);
     // $('video.product__video').load();
     // $('video.product__video').play();
     //     $('.product__thumb-item video .product__video-wrapper video').attr('src',video1);
     // $('.product__thumb-item video .product__video-wrapper video').attr('poster',poster);
 
       $('div#tab-1').html(Benefits);
       $('.product__thumb-item .image-wrap img:eq(0)').attr('src',image1);
       $('.product__thumb-item .image-wrap img:eq(0)').attr('srcset',image1);
        $('img.jtpl-new-pdp-img:eq(2)').attr('src',image2);
        $('img.jtpl-new-pdp-img:eq(2)').attr('srcset',image2);
        $('img.jtpl-new-pdp-img:eq(3)').attr('src',image3);
        $('img.jtpl-new-pdp-img:eq(3)').attr('srcset',image3);
        $('img.jtpl-new-pdp-img:eq(4)').attr('src',image4);
        $('img.jtpl-new-pdp-img:eq(4)').attr('srcset',image4);
        $('img.jtpl-new-pdp-img:eq(5)').attr('src',image5);
        $('img.jtpl-new-pdp-img:eq(5)').attr('srcset',image5);
        $('img.jtpl-new-pdp-img:eq(6)').attr('src',image6);
        $('img.jtpl-new-pdp-img:eq(6)').attr('srcset',image6);
    // var pro_meta_val = $(this).attr('pro-meta-val');
    var pro_meta1_val = $(this).attr('pro_meta1_val');
    $('.main-desc-wrapp1').html(pro_meta1_val);
      // $('.jtpl-add-pro-wrapper').html(pro_meta_val)
    $('.product-single__title').text(pro_title);
     $('#tab-2').html('<p>'+pro_dec+'</p>');
      $('img.jtpl-new-pdp-img').attr('data-srcset', pro_img);
     $('.product__price').text(pro_price)
    $(".product-single__variants option").attr('value',pro_variant_id)

//     setTimeout(function() {
//     $('.jtpl-new-pdp-img').each(function() {
//         var imgg = $(this).attr('data-src');
//         $(this).attr('src', imgg);
//         $(this).attr('srcset', imgg);
//     });
// }, 2000);
});


  
  $('body').on('click', '.cstm-add-quantity.product__quantity button.js-qty__adjust.js-qty__adjust--plus', function() {
    var inputField = $(this).closest('.js-qty__wrapper').find('input');
    var newValue = parseInt(inputField.val()) || 0; // Default to 0 if input value is not a number
    var getPlusval = newValue + 1;
    console.log(getPlusval);
    $(this).closest('.js-qty__wrapper').find('input').val(getPlusval);
});

   $('body').on('click', 'button.js-qty__adjust.js-qty__adjust--minus', function() {
       var inputField1 = $(this).closest('.js-qty__wrapper').find('input');
    var newValue1 = parseInt(inputField1.val()) || 0; // Default to 0 if input value is not a number
    var getMinusval = newValue1 - 1;
    console.log(getMinusval);
     if(getMinusval >= 1){
    $(this).closest('.js-qty__wrapper').find('input').val(getMinusval);
     }
    });
  //$('.meta-product-wrapper.selected').click();
function sliderTab(){
  $('.slick-slider .custom_arrow').click(function(){
    $('.mb-new-tab-mission-wrapper.widescreen--hide .tab-inner-content').find('.sec-tab').removeClass('active');
    var activeIndex = $('.mb-tab-videoinner-contents .sec-tab-video-inner-content.slick-current').data('slick-index');
    $('.mb-new-tab-mission-wrapper.widescreen--hide .tab-inner-content[data-count="' + activeIndex + '"]').find('.sec-tab').addClass('active');
      var tabPosition = $('.mb-new-tab-mission-wrapper.widescreen--hide .tab-inner-content[data-count="' + activeIndex + '"]').position().left;
    $('.jtpl-tab-inner-content-wraper').animate({ scrollLeft: tabPosition }, 'slow'); 
});
}
  

    $(document).on("click","p.radio-main-inner",function(){
   $('.vector_single_data').removeClass('active_tab');
      var val = $(this).find('input[type="radio"]:checked').val();
     $('.vector_single_data[data-handle="'+val+'"]').addClass('active_tab')
  });


    $(document).on("click",".vector_single_data",function(){
     var data_value =   $(this).attr('data')
    $('.first-input.custom-radio-buttons p.radio-main-inner input[value="'+data_value+'"]').trigger('click');
     });

  
  $(document).on("click",".tab-inner-content",function(){
   var id = $(this).find('.sec-tab').attr('data-attr');
  // if($(window).width() >768){
    $('.sec-tab-video-inner-content').css('display', 'none');
    $('.sec-tab').removeClass('active');
      $('.sec-tab-video-inner-content[data-id="'+id+'"]').css('display', 'block');
    $('.sec-tab[data-attr="'+id+'"]').addClass('active');
  $('button.custom_arrow.slick-arrow').trigger('click');
  // }
  //  else
  // {
  //    $('.sec-tab').removeClass('active');
  // var slideno = $(this).attr('data-count');
  // $(this).find('.sec-tab').addClass('active');
  //  $('.mb-tab-videoinner-contents').slick('slickGoTo', slideno);
  // }
});

  //   $('.mb-tab-videoinner-contents').slick({
  //   slidesToShow: 1,
  //   infinite:false,
  //   slidesToScroll: 1,
  //   adaptiveHeight:true,
  //   arrows:true,
  //    nextArrow:'<button aria-label="Next" class="slick-next custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M43 41C43 42.1046 42.1046 43 41 43L2 43C0.895432 43 0 42.1046 0 41L0 2C0 0.895432 0.895432 0 2 0L41 0C42.1046 0 43 0.895432 43 2L43 41Z" fill="#35C6F2"/><path d="M18.5 15.5L24.5 21.5L18.5 27.5" stroke="black" stroke-width="2"/></svg></button>',
  //   prevArrow:'<button aria-label="Prev" class="slick-prev custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M0 2C0 0.895431 0.895431 0 2 0L41 0C42.1046 0 43 0.895431 43 2V41C43 42.1046 42.1046 43 41 43H2C0.895431 43 0 42.1046 0 41L0 2Z" fill="#35C6F2"/><path d="M24.5 27.5L18.5 21.5L24.5 15.5" stroke="black" stroke-width="2"/></svg></button>',
  //   dots:true
  // });
  //  sliderTab();




 
});

  /** 27-2-2024 Class BMB tab start***/
if(window.location.href.indexOf('#') > -1){
  var handle = window.location.href.split('#')[1];
$('.jtpl_video_title_wrapp_containers').find('.image_title_wrapp').hide();
$('.jtpl_video_title_wrapp_containers').find('p.jtpl-monthly-titles').hide();
$('.jtpl_video_title_wrapp_containers[tab_data="'+handle+'"]').removeClass('jtpl_burns');
$('.jtpl_video_title_wrapp_containers[tab_data="'+handle+'"]').find('.image_title_wrapp').show();
$('.jtpl_video_title_wrapp_containers[tab_data="'+handle+'"]').find('p.jtpl-monthly-titles').show();
$('.jtpl_image_title_wrapp_containerss').addClass('jtpl-bjj');


    var first_tab_val = []; 
$('.inner_main_content').each(function() {
    var tab_value = $(this).attr('tab_first_data'); 
if(handle == tab_value ){
  var first_tab_val = $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-tactical-all');
 $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb');
   $('.inner_main_content[tab_first_data="'+handle+'"]').find('p.jtpl-monthly-titles').show();
  $('.inner_main_content[tab_first_data="'+handle+'"]').find('.image_title_wrapp').show();
} 
});
}


$('body').on('click','h3.product-tabs-data.jtpl-sport-tab',function () {
  $('a.jtpl-tactical-all').trigger('click');
});

$('body').on('click','h3.product-tabs-data.jtpl-class-tab',function () {
  $('a.jtpl-class-bmb-all').trigger('click');
});

$('body').on('click','h3.product-tabs-data.jtpl-program-tab',function () {
  $('a.jtpl-tab1-monthly-workout').trigger('click');
});

$('body').on('click','h3.product-tabs-data.jtpl-tactical-tab ',function () {
  $('a.jtpl-tactical-all').trigger('click');
});



$('body').on('click','h3.product-tabs-data',function () {
var data_attr = $(this).attr('value');
  var data_tab_attr =  $('.videos_main_tab').find('a.is__active').attr('data-parent');
  var class_tab_attr = $('.videos_main_tab').find('a.jtpl-main-class-tab.is__active').attr('data-parent');
 var data_tab_attr_val = $('a.is__active[data-parent="'+data_attr+'"]').trigger('click');
});
             

$('body').on('click','h3.product-tabs-data',function () {
 var classdatas = $(this).attr('data-url');
 var classTabValues = $('h3.product-tabs-data.jtpl-class-tab').attr('data-url');
  if (classdatas.includes(classTabValues)){
 $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-all');
          // $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb');
         $('p.jtpl-bmb-title').css('display','block');
    }
});

  
$('body').on('click','.videos_main_tab.custom_tags a',function () {
 var  getHandles = $(this).attr('data-value'); 
  var ClassBmbValues = $('a.class-bmb-tab1').attr('data-value');
var class_all = $('a.jtpl-class-bmb-all').attr('data-value');
var class_strength = $('a.jtpl-class-strength').attr('data-value');
 
 if (getHandles.includes(ClassBmbValues)) {
$('p.jtpl-bmb-title').show();
$('.jtpl_image_title_wrapp_containers_class_bmb').removeClass('jtpl-class-bmb');
   $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb-wrapper');
      $('.parent_main_wrapp').css('display','block');
    } else{
$('p.jtpl-bmb-title').hide();
$('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb');
   $('.jtpl_image_title_wrapp_containers_class_bmb').removeClass('jtpl-class-bmb-wrapper');
$('.parent_main_wrapp').css('display','block');
 }

  if (getHandles.includes(class_all)) {
    $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb-all');
   }
  else{
     $('.jtpl_image_title_wrapp_containers_class_bmb').removeClass('jtpl-class-bmb-all');
  }

if (getHandles.includes(class_strength)) {
     $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb-strength');
}
  else{
      $('.jtpl_image_title_wrapp_containers_class_bmb').removeClass('jtpl-class-bmb-strength');
  }
  
});
  /** 27-2-2024 class BMB tab end ***/







 var programurl = window.location.href; 

if(programurl.includes("#build-move-burn")){
  $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb-wrapper');
}

if(programurl.includes("#build-move-burn-library")){
  $('.jtpl_image_title_wrapp_container').addClass('jtpl_limitless_burn');
}




if(programurl.includes("#month-1")){
   $('.jtpl_image_title_wrapp_container').addClass('jtpl-month-tab1');
}
if(programurl.includes("#month-2")){
   $('.jtpl_image_title_wrapp_container').addClass('jtpl-month-tab2');
}
if(programurl.includes("#month-3")){
   $('.jtpl_image_title_wrapp_container').addClass('jtpl-month-tab3');
     $('.jtpl_image_title_wrapp_container').removeClass('jtpl_limitless_burn');
}

if(programurl.includes("#month-4")){
   $('.jtpl_image_title_wrapp_container').addClass('jtpl-month-tab4');
}


if(programurl.includes("#month-1")){
    $('.jtpl-month3-tab').hide();
}
if(programurl.includes("#resisted-pilates")){
  $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb');
}
if(programurl.includes("#strength")){
  $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb jtpl-class-bmb-strength');
}
if(programurl.includes("#all_classes")){
  $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb jtpl-class-bmb-all');
}





  /** 27-2-2024 Tactical tab start***/

  var tacturl = window.location.href; 
    if(tacturl.includes("#pickleball") ) {
    $('.jtpl_image_title_wrapp_containerss').addClass('jtpl_pickleball');
         $('.jtpl_image_title_wrapp_containerss').removeClass('jtpl-tactical-all jtpl-bjj jtpl-bjj-month-wrapper');
 }
   else{
     $('.jtpl_video_title_wrapp_containers.jtpl_months.jtpl_pickleball').hide();
   }
   
   if(tacturl.includes("#bjj") ) {
    $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-bjj-month-wrapper');
         $('.jtpl_image_title_wrapp_containerss').removeClass('jtpl-tactical-all jtpl-bjj');
   }
   if(tacturl.includes("#acft") ) {
    $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-bjj jtpl-tactical-all');
   }
  if(tacturl.includes("#all_tactical") ) {
    $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-bjj jtpl-tactical-all');
   }

$("h3.product-tabs-data").click(function(){
 var datas = $(this).attr('data-url');
  var programTabValues = $('h3.product-tabs-data.jtpl-tactical-tab').attr('data-url');
  if (datas.includes(programTabValues)){

 $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-tactical-all');
          $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-bjj');
         $('p.jtpl-monthly-titles').css('display','block');
    }
  // if(tacturl.includes("#bjj") ) {
  //   $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-bjj-month-wrapper');
  //        $('.jtpl_image_title_wrapp_containerss').removeClass('jtpl-tactical-all jtpl-bjj');
  //  } 
});



  
$('body').on('click','.videos_main_tab.custom_tags a',function () {
 var  getHandles = $(this).attr('data-value'); 
   var pickleball_value = $('a.jtpl-tab3-pickleball').attr('data-value');
 
  var monthlyTabValues = $('a.jtpl-tab1-monthly-workoutss').attr('data-value');
  var tactical_all = $('a.jtpl-tactical-all').attr('data-value');
          
if (getHandles == pickleball_value){
    $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-pickleball');
    $('.jtpl_image_title_wrapp_containerss').removeClass('jtpl-bjj ');
 }
  else{
       $('.jtpl_image_title_wrapp_containerss').removeClass('jtpl-pickleball ');
  }
 
 // if (getHandles == monthlyTabValues) {
  if(getHandles.includes(monthlyTabValues)){
    $('p.jtpl-monthly-titles').hide();

// $('p.jtpl-monthly-titles').show();
    $('.jtpl_video_title_wrapp_containers.jtpl_months[tab_data="'+getHandles+'"]').find('p.jtpl-monthly-titles').show();
$('.jtpl_image_title_wrapp_containerss').removeClass('jtpl-bjj');
   $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-bjj-month-wrapper');
      $('.parent_main_wrapp').css('display','block');
    } else{
$('p.jtpl-monthly-titles').hide();
   if(getHandles != 'pickleball'){
$('.jtpl_image_title_wrapp_containerss').addClass('jtpl-bjj');
   }
   $('.jtpl_image_title_wrapp_containerss').removeClass('jtpl-bjj-month-wrapper');
$('.parent_main_wrapp').css('display','block');
 }

  if (getHandles == tactical_all) {
    $('.jtpl_image_title_wrapp_containerss').addClass('jtpl-tactical-all');
                                        
  }
  else{
  
     $('.jtpl_image_title_wrapp_containerss').removeClass('jtpl-tactical-all');
  }
});
  /** 27-2-2024 Tactical tab end ***/









    /** popup cookie start ***/


getcookieData();
getcookieData1();

$('body').on('click','.klaviyo-close-form',function () {
   setTimeout(function(){
    $('.go1272136950 + .kl-private-reset-css-Xuajs1').addClass('flyerhideoutpermanent');
      },500); 
   var cur_urls = window.location.href; 
   if(cur_urls.indexOf('vector-gym-equipment') >-1){
    setCookie('close-vector-gym','close-vector-gym',1);  
  }
     getcookieData();
});


$('body').on('click','.klaviyo-close-form',function () {
   setTimeout(function(){
    $('.go1272136950 + .kl-private-reset-css-Xuajs1').addClass('flyerhideoutpermanent');
      },500); 
    var cur_urlss = window.location.href; 
     if(cur_urlss.indexOf('vector-fitness-systems') >-1){
      setCookie('close-vector-fitness','close-vector-fitness',1);  
    }
      getcookieData1();
});




     /***  onload delete cokie ***/
     var cur_url = window.location.href; 
    // if(cur_url.indexOf('vector-gym-equipment') >-1){
    //    deleteCookie("close-vector-gym");  
   //  }
   //  else{
   //     deleteCookie("close-vector-gym");  
   //  }
    
   //   if(cur_url.indexOf('vector-fitness-systems') >-1){
   //     deleteCookie("close-vector-fitness");  
   //  }
   //    else{
   // deleteCookie("close-vector-fitness");  
   //      }
    

function getcookieData(){
if($('.new_vector_package_cstm_jtpl_inner').length >0 && window.location.href.indexOf('vector-gym-equipment') >-1){
 window.addEventListener('scroll', function(event) {
// add event on scroll
   if (isScrolledIntoView($('.new_vector_package_cstm_jtpl_inner'))) {
      //if in Viewport
     if($('div[data-testid="FLYOUT"]').length ==0){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'X8QQEe']);
     }
     var getcookies = getCookie('close-vector-gym');
        if(getcookies){
          setTimeout(function(){
             $('.needsclick.kl-private-reset-css-Xuajs1').hide();
              $('.go1272136950 + .kl-private-reset-css-Xuajs1').addClass('flyerhideoutpermanent');
              $('.kl-private-reset-css-Xuajs1').removeClass('flyerhideout');
            },500); 
        } else{
        $('.go1272136950 + .kl-private-reset-css-Xuajs1').addClass('flyerhideout');
        }
       
    }else{
     if(isScrolledIntoView($('.galler_desktop_jtpl')) || isScrolledIntoView($('.choose_vector_new_section_jtpl')) ){
     if($('div[data-testid="FLYOUT"] button').length >0){
    // $('div[data-testid="FLYOUT"] button').trigger('click');
       setTimeout(function(){
     $('.kl-private-reset-css-Xuajs1').removeClass('flyerhideout');     
       },300);
    
     }
     }
    }

}, false);
}
}





function getcookieData1(){
if($('.vector-package-main-wrapp').length >0 && window.location.href.indexOf('vector-fitness-systems') >-1){
window.addEventListener('scroll', function(event) {
   
// add event on scroll
// console.log(isScrolledIntoView($('.vector-package-main-wrapp'))+'=='+ isScrolledIntoView($('.site-footer')));
   if (isScrolledIntoView($('.vector-package-main-wrapp'))) {
     if($('div[data-testid="FLYOUT"]').length ==0){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'X8QQEe']);
     }
     var getcookiess = getCookie('close-vector-fitness');
        if(getcookiess){
        
           setTimeout(function(){
             $('.needsclick.kl-private-reset-css-Xuajs1').hide();
              $('.go1272136950 + .kl-private-reset-css-Xuajs1').addClass('flyerhideoutpermanent');
              $('.kl-private-reset-css-Xuajs1').removeClass('flyerhideout');
            },500); 
        } else{
        $('.go1272136950 + .kl-private-reset-css-Xuajs1').addClass('flyerhideout');
        }

   }

}, false);
}
}

/** popup cookie end **/



/**** 13 march 2024 start ***/

// if($('.new_vector_package_cstm_jtpl_inner').length >0 && window.location.href.indexOf('vector-gym-equipment') >-1){
//  window.addEventListener('scroll', function(event) {
// // add event on scroll
//    if (isScrolledIntoView($('.new_vector_package_cstm_jtpl_inner'))) {
//       //if in Viewport
//      if($('div[data-testid="FLYOUT"]').length ==0){
//         window._klOnsite = window._klOnsite || [];
//         window._klOnsite.push(['openForm', 'X8QQEe']);
//      }
//     }else{
//      if(isScrolledIntoView($('.galler_desktop_jtpl')) || isScrolledIntoView($('.choose_vector_new_section_jtpl')) ){
//      if($('div[data-testid="FLYOUT"] button').length >0){
//      $('div[data-testid="FLYOUT"] button').trigger('click');
//      }
//      }
//     }

// }, false);
// }

// if($('.vector-package-main-wrapp').length >0 && window.location.href.indexOf('vector-fitness-systems') >-1){
//  window.addEventListener('scroll', function(event) {
   
// // add event on scroll
// console.log(isScrolledIntoView($('.vector-package-main-wrapp'))+'=='+ isScrolledIntoView($('.site-footer')));
//    if (isScrolledIntoView($('.vector-package-main-wrapp'))) {
//      if($('div[data-testid="FLYOUT"]').length ==0){
//         window._klOnsite = image1._klOnsite || [];
//         window._klOnsite.push(['openForm', 'X8QQEe']);
//      }
//     }else  {
//      if($('div[data-testid="FLYOUT"] button').length >0){
//      $('div[data-testid="FLYOUT"] button').trigger('click');
//      }
//      }

// }, false);
// }


/**** 13 march 2024 end ***/
    


$('.jtpl-ads-vector-package,.ads-vector-system').wrapAll('<div class="parent_all_accoedions_wrapper container"></div>');

$('p.radio-main-inner.no').click(function(){
   // $('.vector_single_data.grid__item.medium-up--two-quarters.active_tab').hide();
   $('.jtpl-ads-vect2-wraper').hide();
  $('.jtpl-ads-vectorcontainer').addClass('jtpl-show-ads-vect');
});

$('p.radio-main-inner.yes_no').click(function(){
     $('.jtpl-ads-vect2-wraper').show();
  $('.jtpl-ads-vectorcontainer').removeClass('jtpl-show-ads-vect');
});



function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height()-180;
  var start_point = elemTop -500;
  return ((elemBottom >= docViewTop) && start_point <docViewTop);

  // var win = $(window);
  //   //Object to Check
  //   obj = $(elem);
  //   //the top Scroll Position in the page
  //   var scrollPosition = win.scrollTop();
  //   //the end of the visible area in the page, starting from the scroll position
  //   var visibleArea = win.scrollTop() + win.height();
  //   //the end of the object to check
  //   var objEndPos = (obj.offset().top + obj.outerHeight());
  //   return(visibleArea >= objEndPos && scrollPosition <= objEndPos ? true : false)

  
}



$(document).ready(function(){  
  
/*** 19-feb-2024 ***/
 var urls = window.location.href;
  if(urls.includes("/collections/vector-travel") ) 
    {
   window.location = "https://kayezen.com/pages/vector-fitness-systems";
    }
   if(urls.includes("collections") ) 
    {
   window.location = "https://kayezen.com/pages/vector-fitness-systems";
    }


  if(urls.includes("/products/vector-personal-training-system" )) 
    {
     window.location = "https://kayezen.com/pages/vector-fitness-systems";
    }

   if(urls.includes("/products/vector-professional-trainer-system" )) 
    {
     window.location = "https://kayezen.com/pages/vector-fitness-systems";
    }
   if(urls.includes("/products/vector-tactical-mobile-system" )) 
     {
      window.location = "https://kayezen.com/pages/vector-fitness-systems";
    }

  if(urls.includes("/products/only-for-test-not-for-sale")){
     window.location = "https://kayezen.com/pages/vector-fitness-systems";
   }
    
  if(urls.includes("/collections/accessories")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }

  
 if(urls.includes("/collections/all")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }

    if(urls.includes("/products/vector-cinch-strap" )) 
    {
     window.location = "https://kayezen.com/pages/vector-fitness-accessories";
    }
  
  
  if(urls.includes("/products/10x-vector-light-heavy-tubes")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }
  if(urls.includes("/products/20x-vector-heavy-tubes")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }
   if(urls.includes("/products/20x-vector-light-heavy-tubes")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }
 if(urls.includes("/products/20x-vector-light-heavy-tubes-1")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }
if(urls.includes("/products/20x-vector-light-tubes")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }

  if(urls.includes("/products/vector-door-anchor")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }
  if(urls.includes("/products/vector-locking-carabiner")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }
   if(urls.includes("/products/vector-long-strap-loop-handle")){
      window.location = "https://kayezen.com/pages/vector-fitness-accessories";
   }
    
  if(urls.includes("/products/vector-long-torso-strap" )) 
    {
     window.location = "https://kayezen.com/pages/vector-fitness-accessories";
    }
   if(urls.includes("/products/vector-mobile-tactical-bag" )) 
    {
     window.location = "https://kayezen.com/pages/vector-fitness-accessories";
    }
   if(urls.includes("/products/vector-short-strap-loop-handle" )) 
    {
     window.location = "https://kayezen.com/pages/vector-fitness-accessories";
    }
   if(urls.includes("/products/vector-tree-anchor" )) 
    {
     window.location = "https://kayezen.com/pages/vector-fitness-accessories";
    }
    if(urls.includes("/products/vector-wall-rack-anchor" )) 
    {
     window.location = "https://kayezen.com/pages/vector-fitness-accessories";
    }
   
 
  
/*** 14-dec-2023 ***/


  
  $('body').on('click','.jtpl-tab1-monthly-workout',function () {
  $('.jtpl_image_title_wrapp_container').addClass('jtpl-month-tab1');
    $('.jtpl-month3-tab').hide();
  });

$("h3.product-tabs-data").click(function(){
 var data = $(this).attr('data-url');
      var programTabValue = $('h3.product-tabs-data.jtpl-program-tab').attr('data-url');
   if (data.includes(programTabValue)){
        $('.jtpl-month3-tab').hide();
         $('.jtpl_image_title_wrapp_container').removeClass('jtpl_limitless_burn');
         $('p.jtpl-monthly-title').css('display','block');
    }
});


  $("h3.product-tabs-data").click(function(){
    var data = $(this).attr('data-url');
    // alert(data)
      var programTabValue = $('h3.product-tabs-data.jtpl-class-tab').attr('data-url');
   
   if (data.includes(programTabValue)){
 
        // $('.jtpl-month3-tab').hide();
      $('.jtpl_image_title_wrapp_containers_class_bmb').addClass('jtpl-class-bmb jtpl-class-bmb-all');
         // $('p.jtpl-monthly-title').css('display','block');
    }
});


  /*** month3 tab js****/

  
$('.jtpl_image_title_wrapp_container.jtpl-month-tab3').removeClass('jtpl_limitless_burn');

$('body').on('click','.videos_main_tab.custom_tags a',function () {
 $('.jtpl_image_title_wrapp_container.jtpl-month-tab3').removeClass('jtpl_limitless_burn');

  var  getHandle = $(this).attr('data-value'); 
 var monthlyTabValue = $('a.jtpl-tab1-monthly-workout').attr('data-value');
 var month3tab = $('a.jtpl-tab4-monthly-workout.is__active').attr('data-value');
   $('.jtpl_video_title_wrapp_containers').removeClass('jtpl-month-tab4');
    if (getHandle.includes(monthlyTabValue)) {
$('p.jtpl-monthly-title').show();
$('.jtpl_image_title_wrapp_container').removeClass('jtpl_limitless_burn');
       $('.jtpl_image_title_wrapp_container.jtpl-month-tab3').removeClass('jtpl_limitless_burn');
      $('.parent_main_wrapp').css('display','block');
    }
    else{  
$('p.jtpl-monthly-title').hide();
// $('.jtpl_image_title_wrapp_container').addClass('jtpl_limitless_burn');
$('.parent_main_wrapp').css('display','block');
   }


  if (getHandle.includes(month3tab)) {  
    $('p.jtpl-monthly-title').show();
   $('.jtpl_image_title_wrapp_container.jtpl-month-tab3').removeClass('jtpl_limitless_burn');
   $('.jtpl_image_title_wrapp_container').removeClass('jtpl_limitless_burn');
    $('.jtpl_image_title_wrapp_container').addClass('jtpl-month-tab3')
      $('.parent_main_wrapp').css('display','block');
    }
    else{
    //  alert(888)
    // $('.jtpl_image_title_wrapp_container.jtpl-month-tab3').removeClass('jtpl_limitless_burn');
     $('.jtpl_image_title_wrapp_container').removeClass('jtpl-month-tab3')
    } 
});



  /*** month2 tab js****/
  
$('body').on('click','.videos_main_tab.custom_tags a',function () {
 var  getHandle = $(this).attr('data-value'); 
  var monthlyTabValue = $('a.jtpl-tab1-monthly-workout').attr('data-value');
 var month2tab = $('a.jtpl-tab3-monthly-workout.is__active').attr('data-value');
   $('.jtpl_video_title_wrapp_containers').removeClass('jtpl-month-tab2');
    if (getHandle.includes(monthlyTabValue)) {
$('p.jtpl-monthly-title').show();
$('.jtpl_image_title_wrapp_container').removeClass('jtpl_limitless_burn');
      $('.parent_main_wrapp').css('display','block');
    }
    else{  
      $('.jtpl_image_title_wrapp_container.jtpl-month-tab3').removeClass('jtpl_limitless_burn') 
  $('.jtpl-month4-tab p.jtpl-monthly-title').show();
$('.jtpl_image_title_wrapp_container').addClass('jtpl_limitless_burn');
$('.parent_main_wrapp').css('display','block');
  }

   if (getHandle == 'month-4'){
     $('.jtpl-month4-tab p.jtpl-monthly-title').show();
     $('.jtpl_image_title_wrapp_container').addClass('jtpl-month-tab4');
      $('.jtpl_image_title_wrapp_container').removeClass('jtpl-month-tab1');
   }
  else{
        $('.jtpl_image_title_wrapp_container').removeClass('jtpl-month-tab4');
  }


  
  if (getHandle.includes(month2tab)) {   
$('p.jtpl-monthly-title').show();
$('.jtpl_image_title_wrapp_container').removeClass('jtpl_limitless_burn');
    $('.jtpl_image_title_wrapp_container').addClass('jtpl-month-tab2')
      $('.parent_main_wrapp').css('display','block');
    }
    else{
      
      $('.jtpl_image_title_wrapp_container.jtpl-month-tab3').removeClass('jtpl_limitless_burn')
     $('.jtpl_image_title_wrapp_container').removeClass('jtpl-month-tab2')
    }

if (getHandle == 'build-move-burn-library') {   
$('.jtpl_image_title_wrapp_container').addClass('jtpl_limitless_burn');
    }
    else{
      $('.jtpl_image_title_wrapp_container').removeClass('jtpl_limitless_burn');
     }
  
});
  

if (window.innerWidth < 768) {
var position = $(window).scrollTop();
  $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll <= 0){
        $('.mobile_show').css("display","block");
      }else if (scroll > position) {
          $('.mobile_show').css("display","none");
          $('.video_page_tabs').css("top",0);
           $('.left_side_tabs_main').css("top",0);  
      } else {
          $('.mobile_show').css("display","block");
          $('.video_page_tabs').css("top","60px");
          $('.left_side_tabs_main').css("top",60);
      }
      position = scroll;
    // console.log(scroll);
  });    
}

$('.product-tabs-data[data-url="sports-specific"]').click(function () {
  filterFunctionality();
});

$('.videos_main_tab.custom_tags a').click(function () {
   $('.sub-tittle-tab').hide();
   var dataVal = $(this).attr('data-value');
  $('.sub-tittle-tab.'+dataVal).show();
   //filterFunctionality();
});
                                          
$('.class-jt input[type="radio"]').click(function () {
    var count ='';
   
 var body_region =  $('input[name="body_region"]:checked').val();
  // console.log(body_region);     
 var coach =    $('input[name="coach"]:checked').val();
  // console.log(coach);
  var duration =   $('input[name="duration"]:checked').val();
    // console.log(duration);
    var combo = body_region+','+coach+','+duration;
 //  console.log('check----'+combo);
    var combo_split =combo.split(',')
    if(typeof body_region != 'undefined' && typeof coach  != 'undefined' && typeof duration !='undefined'){
       // console.log(body_region);
         // console.log(coach);
         // console.log(duration);
        $('.parent_main_wrapp .image_title_wrapp.custom_video').hide();
     var get_slect_val =    $('.videos_main_tab.custom_tags a.is__active').attr('data-value');
      alert(get_slect_val)
     var  get_slect_val_handle = get_slect_val.replace('-',' ');
     console.log(get_slect_val_handle);
    if(get_slect_val != 'all') {
    $(`.parent_main_wrapp .image_title_wrapp.custom_video[data_handle="${get_slect_val_handle}"]`).each(function () {
   var get_tag = $(this).attr('vid-tag');
   console.log(get_tag) ;
       var spilt_value = get_tag.split(',');
var allExists = combo_split.every(element => spilt_value.includes(element));
     // console.log(allExists);
      if(allExists){
        $(this).show();
        count++;
      }
        
    });
    } else {
        $('.parent_main_wrapp .image_title_wrapp.custom_video').each(function () {
   var get_tag = $(this).attr('vid-tag');
       var spilt_value = get_tag.split(',');
var allExists = combo_split.every(element => spilt_value.includes(element));
      if(allExists){
        $(this).show();
        count++;
      }
        
    });
    }
    }
});

// sports specific

$('.spt-spec input[type="radio"]').click(function () {
    var counts ='';  
 var body_region1 =  $('input[name="body_region1"]:checked').val();
  // console.log(body_region1);     
 var coach1 =    $('input[name="coach1"]:checked').val();
  // console.log(coach1);
  var duration1 =   $('input[name="duration1"]:checked').val();
    // console.log(duration1);
    var combo1 = body_region1+','+coach1+','+duration1;
   console.log('check----'+combo1);
    var combo_split1 =combo1.split(',')
    if(typeof body_region1 != 'undefined' && typeof coach1  != 'undefined' && typeof duration1 !='undefined'){
        $('.parent_main_wrapp .image_title_wrapp.custom_video').hide();
     var get_slect_vals =    $('.videos_main_tab.custom_tags a.is__active').attr('data-value');

     var  get_slect_val_handles = get_slect_vals.replace('-',' ');
      console.log(get_slect_val_handles);
    if(get_slect_vals != 'all') {
      alert(99)
    $(`.parent_main_wrapp .image_title_wrapp.custom_video[data_handle="${get_slect_val_handles}"]`).each(function () {
   var get_tags = $(this).attr('vid-tag');
     console.log(get_tag) ;
       var spilt_values = get_tags.split(',');
var allExistss = combo_split1.every(element => spilt_values.includes(element));
      if(allExistss){
        $(this).show();
        counts++;
      }
        
    });
    } else {
        $('.parent_main_wrapp .image_title_wrapp.custom_video').each(function () {
   var get_tags = $(this).attr('vid-tag');
    //console.log(get_tag) ;
       var spilt_values = get_tags.split(',');
      //  console.log(spilt_value);
       //  console.log(spilt_value[0]);
      // console.log(spilt_value[1]);
        //console.log(spilt_value[2]);
var allExistss = combo_split1.every(element => spilt_values.includes(element));
     // console.log(allExists);
      if(allExistss){
        $(this).show();
        counts++;
      }
        
    });
    }
    }
});


// var img_height = $("div#main_image1").height();
//   $(".jtpl-slider-img .slick-slide a.btn img").css("height",img_height);

   $(".main_video_section_wrapp").each(function(){
   var data_head = $(this).attr("data-heading");
    $(".main_video_section_wrapp[data-heading='"+data_head+"']").find(".videos_main_tab p").eq(0).trigger("click");
}); 

  $(window).scroll(function() {
    $(".main-outer-workout").each(function(){
      var top_of_element = $(this).offset().top + 100;
      var top_of_element_2 = $(this).offset().top - 100;
      var bottom_of_element = top_of_element + $(this).outerHeight() ;
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight() - 100;
      var top_of_screen = $(window).scrollTop();
      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && (top_of_screen < top_of_element) ){
        $(".main-outer-workout video").trigger("pause");
        $(this).find(".vector-video-sec video").trigger("play");
        var data = $(this).find("h2").text();
        console.log(data);
      }
    });
          if ($(".section-start-system-accessories-page  .main_tabs_content").isOnScreen()) {
            setTimeout(function(){
              $(".wistia_responsive_wrapper video").trigger("pause");
            $(".section-start-system-accessories-page  .main_tabs_content .inner_mainwork:visible").find(".wistia_responsive_wrapper video").trigger("play");
              $(".section-start-system-accessories-page  .main_tabs_content .inner_mainwork:visible").find(".wistia_responsive_wrapper video").prop('muted', false);
            },500);
        
          }else{
          $(".section-start-system-accessories-page  .main_tabs_content .inner_mainwork").find(".wistia_responsive_wrapper video").trigger("pause");
              
          } 
    
    
  });




  $(".image_with_video .video_main_icon").click(function(){
    $(".page-gold-main-image").show();
    $(".image_with_video .video-section-goldsgym").hide();
    $(".image_with_video .video-section-goldsgym video").trigger("pause");
    $(this).parents(".page-gold-main-image").hide();
    $(this).parents(".image_with_video").find(".video-section-goldsgym").show();
    $(this).parents(".image_with_video").find(".video-section-goldsgym video").trigger("play");
  });
  setTimeout(function(){
    jQuery(".Custom-testimonials-thumbnail-slider").slick("setPosition");
  },100);
});
$(document).ready(function(){
  setTimeout(function(){
    $(".product__thumb-item").first().trigger("click");
  },550);
  setTimeout(function(){
    if($(window).width() <768){
      $(".product__photo-dots li").first().trigger("click");
    }
  },550);
  $(".variant-input-wrap select").on('change', function() {
    var current_url = $(location).attr('href'); 
    console.log(current_url);
    jQuery.ajax({
      type: 'GET',
      url: current_url,
      dataType: 'html',
      success: function(data){
        //   console.log(data);
        $('.product__photos').html($(data).find('.product__photos').html());

        if($(window).width() <768){
          console.log("less");
          $('.custom--slider--here').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:true,
            adaptiveHeight: true,
            centerMode: true,
            centerPadding: '0px',
            dots: true   
          });
      
        }
        else{
          console.log("greater");
          $('.custom--slider--here').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:true,
            fade: true,
            infinite: true,
            adaptiveHeight: true,
            asNavFor: '.product__thumbs'
          });
        
        
        }
        $('.product__thumbs').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows:true,
          focusOnSelect: true,
          asNavFor: '.custom--slider--here',
          dots: false,
          infinite: false
        });
        $(".product__photos .image-wrap img").css("opacity","1");

      }
    });




    
  });

  $(".variant-input-wrap label").on('click', function() {
    setTimeout(function(){
      var current_url = $(location).attr('href'); 
      console.log(current_url);
      jQuery.ajax({
        type: 'GET',
        url: current_url,
        dataType: 'html',
        success: function(data){
          //   console.log(data);
          $('.product__photos').html($(data).find('.product__photos').html());
          $(".product__photos .image-wrap img").css("opacity","1");

          $('.custom--alt-images--here.custom--slider--here').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:true,
            adaptiveHeight: true,
            centerMode: true,
            centerPadding: '0px',
            dots: true   
          });
          if($(window).width() <767){
            console.log("less");
            $('.custom--slider--here').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:true,
              adaptiveHeight: true,
              centerMode: true,
              centerPadding: '0px',
              dots: true   
            });
          }
          else{
            console.log("greater");
            $('.custom--slider--here').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:true,
              fade: true,
              infinite: true,
              adaptiveHeight: true,
              asNavFor: '.product__thumbs'
            });
          }
          $('.product__thumbs').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows:true,
            focusOnSelect: true,
            asNavFor: '.custom--slider--here',
            dots: false,
            infinite: false
          });
        }
      });
    },100);
  });


});

$('.custom--slider--here').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: true,
  centerMode: true,
  centerPadding: '0px',
  dots: true,
  infinite: false  // Disable infinite looping
});

$('.product__thumbs').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows:true,
  focusOnSelect: true,
  asNavFor: '.custom--slider--here',
  dots: false,
  infinite: false
});

$(document).ready(function() {
  var number_on_load =$("input.variant-input-type-custom:checked").attr("data-num");
  $(".main-title-vector-product").each(function(){
    var ssss= $(this).attr("data-index");
    if(number_on_load == ssss){
      $(this).show();
    }
    else{
      $(this).hide();
    }
  });
  $(".variant-input-show-title label").click(function(){
    var number =$(this).parents(".variant-input").attr("data-title-index");
    $(".variant-input input:checked").addClass("clickeddd");
    $(".main-title-vector-product").each(function(){
      var number1= $(this).attr("data-index");
      if(number==number1){
        $(this).show();
      }
      else{
        $(this).hide();
      }

    });
  });

  var main_slider_vid = $(".system_section_new_page.main_multiple_column div#wistia-5884rnz5b2-2").height();

  $(".system_section_new_page.main_multiple_column .slider_for_mobile button.custom-slider-arrow").css("top",main_slider_vid);

});
  




$(".Main_VTV-Image-block .VTV-Image-block-content").click(function(){
  $(".Main_VTV-Image-block .VTV-Image-block-content").removeClass("is__active");
  $(this).addClass("is__active");
  var handle=$(this).attr("data-handle").trim();
  $(".vtv-all-videos_content_holder").each(function(){
    var Each_handle=$(this).attr("data-handle").trim();
    if(Each_handle.includes("~~")){
      var numbersArray = Each_handle.split('~~');
      var all=' ';
      var count = 0;
      $.each(numbersArray, function(index, value) { 
        var new_value= value.replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        if( new_value == handle ){
          all += new_value; 
          count++;
        }
      });
      if( count == 0 ){
        $(this).hide();
      }
      else{
        $(this).show();
      }
    }
    else if( Each_handle == handle){
      $(this).show();
    }
    else{
      $(this).hide();
    }
  });
  if($(".vtv-all-videos_content_holder:visible").length == 0){
    $(".Novideos").addClass("Novideo_showed");
    console.log("0");
  }
  else{
    console.log("1");
    $(".Novideos").removeClass("Novideo_showed");
  }

});
$(".Main_VTV-Image-block .VTV-Image-block-content").click(function(){
  var data_handle =  $(".VTV-Image-block-content.is__active").attr("data-handle");
  if(data_handle == 'all'){
    $(".vtv-all-videos_content_holder").show();
    $(".Novideos").removeClass("Novideo_showed");
  }
});
$(".desktop-button").hover(function(){
  $(".desktop_menu").addClass('active');
});
$(document).mouseover(function (e) {
  var popup = $(".desktop-button.right_shop_btn_header");
  var popup1 = $(".desktop_menu");
  if (!$('.desktop-button.right_shop_btn_header').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
    if (!$('.desktop_menu').is(e.target) && !popup1.is(e.target) && popup1.has(e.target).length == 0) {
      $(".desktop_menu ").removeClass('active');
    }
  }
});
function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal)) {
    parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}
function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}
$('.input-group').on('click', '.button-plus', function(e) {
  incrementValue(e);
});
$('.input-group').on('click', '.button-minus', function(e) {
  decrementValue(e);
});
$(document).ready(function() {
  var screenwidth = $( window ).outerWidth();
  var containerwidth = $('div#multi-palaner-text .page-width').width();

  var calculated = screenwidth - containerwidth;
  var finalval = calculated/2;
  $('.Testimonial-with-star-rating').css('padding-right',finalval+"px");
  $("div#cta-btn-pages-trainer").on("click",function(){
    $('html, body').animate({
      scrollTop: $("#vector-trainer-system").offset().top
    }, 2000);
  }); 
  $('.cstm_bbtn').on('click',function(){
    $('html, body').animate({
      scrollTop: $(".cstm_trainer").offset().top - 99
    }, 2000);
  });  
});
$(window).on('resize', function(){
  var screenwidth = $( window ).outerWidth();
  var containerwidth = $('div#multi-palaner-text .page-width').width();

  var calculated = screenwidth - containerwidth;
  var finalval = calculated/2;

  $('.Testimonial-with-star-rating').css('padding-right',finalval+"px");
});

$(document).ready(function(){
  


  $(".container-custom-tab .choice.mx-2.danger-color").on("click", function(){
    $(".container-custom-tab .choice.mx-2.danger-color").removeClass("expand unset ");
    $(".container-custom-tab .choice.mx-2.danger-color").addClass("small");
    $(this).removeClass("small");
    $(this).addClass("expand");
  });


});


$(".hero__text-shadow.custom-data-hide a.hero__text-shadow-button-content").click(function(e) {
  e.preventDefault();
  var header_height= $(".personal_trainor_heador").height();
  $('html, body').animate({
    scrollTop: $("#shopify-section-vector-trainer-system").offset().top - header_height
  }, 2000);
});


$(".heading_btn.personal_container_buttons.custom-main-scroll-button a").click(function(e) {
  e.preventDefault();
  var header_height= $(".personal_trainor_heador").height();
  $('html, body').animate({
    scrollTop: $("#shopify-section-vector-trainer-system").offset().top - header_height
  }, 2000);
});
$(document).ready(function(){
  $('.Testimonial_second .Custom-testimonials-thumbnail-slider').slick({
    slidesToShow:1,
    slidesToScroll: 1,
    arrows:true,
    nextArrow:'<button aria-label="Next" class="slick-next custom_arrow"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.5L7.5 7.5L1.5 13.5" stroke="black" stroke-width="2"/></svg></button>',
    prevArrow:'<button aria-label="Prev" class="slick-prev custom_arrow"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 13.5L1.5 7.5L7.5 1.5" stroke="black" stroke-width="2"/></svg></button>',
    adaptiveHeight: true,
    autoplay: true,
    speed:2000,
    centerMode: true,
    infinite: true,
    centerPadding: '10px',
    loop:false,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          arrows:true,

        }
      }
    ]

  });
  if ($(window).width() < 769) {
    var timage_height = $(".testimonials-wrapper .Custom-testimonials-thumbnail-slider .image_sec").height();
    var timage_final_height = timage_height/2;
    $(".testimonials-wrapper .Custom-testimonials-thumbnail-slider button.slick-arrow").css("top",timage_final_height);
  }



  
});





$(window).on('load resize',function(){
  if($(window).width() < 767){
    $('.show-slider .shipping-text-mobile-slider').slick({
      slidesToShow:2,
      slidesToScroll: 1,
      arrows:false,
      adaptiveHeight: false,
      centerMode: true,
      centerPadding: '0px',
      dots: false,
      autoplay:true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows:false,
            adaptiveHeight: false,
            centerMode: true,
            centerPadding: '0px',
            dots: false,
            infinite:false,
            autoplay:true
          }
        }
      ]
    });

  }

  if ($(window).width() < 769) {
    var timage_height = $(".testimonials-wrapper .Custom-testimonials-thumbnail-slider .image_sec").height();
    var timage_final_height = timage_height/2;
    $(".testimonials-wrapper .Custom-testimonials-thumbnail-slider button.slick-arrow").css("top",timage_final_height);
  }
});

function maineliteslider(){
  $('.custom_eliteteam-page .custom_mulicolums.custom_blocks_slider .main_rpeated_div-wrapp').slick({
    infinite:true,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows:true,
    nextArrow:'<button class="slick-next custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M43 41C43 42.1046 42.1046 43 41 43L2 43C0.895432 43 0 42.1046 0 41L0 2C0 0.895432 0.895432 0 2 0L41 0C42.1046 0 43 0.895432 43 2L43 41Z" fill="#35C6F2"/><path d="M18.5 15.5L24.5 21.5L18.5 27.5" stroke="black" stroke-width="2"/></svg></button>',
    prevArrow:'<button class="slick-prev custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M0 2C0 0.895431 0.895431 0 2 0L41 0C42.1046 0 43 0.895431 43 2V41C43 42.1046 42.1046 43 41 43H2C0.895431 43 0 42.1046 0 41L0 2Z" fill="#35C6F2"/><path d="M24.5 27.5L18.5 21.5L24.5 15.5" stroke="black" stroke-width="2"/></svg></button>',
    dots: false,
    responsive: [
    {
      breakpoint: 1000,
      settings: {
        arrows:true,
        nextArrow:'<button class="slick-next custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M43 41C43 42.1046 42.1046 43 41 43L2 43C0.895432 43 0 42.1046 0 41L0 2C0 0.895432 0.895432 0 2 0L41 0C42.1046 0 43 0.895432 43 2L43 41Z" fill="#35C6F2"/><path d="M18.5 15.5L24.5 21.5L18.5 27.5" stroke="black" stroke-width="2"/></svg></button>',
        prevArrow:'<button class="slick-prev custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M0 2C0 0.895431 0.895431 0 2 0L41 0C42.1046 0 43 0.895431 43 2V41C43 42.1046 42.1046 43 41 43H2C0.895431 43 0 42.1046 0 41L0 2Z" fill="#35C6F2"/><path d="M24.5 27.5L18.5 21.5L24.5 15.5" stroke="black" stroke-width="2"/></svg></button>',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        arrows:true,
        nextArrow:'<button class="slick-next custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M43 41C43 42.1046 42.1046 43 41 43L2 43C0.895432 43 0 42.1046 0 41L0 2C0 0.895432 0.895432 0 2 0L41 0C42.1046 0 43 0.895432 43 2L43 41Z" fill="#35C6F2"/><path d="M18.5 15.5L24.5 21.5L18.5 27.5" stroke="black" stroke-width="2"/></svg></button>',
    prevArrow:'<button class="slick-prev custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M0 2C0 0.895431 0.895431 0 2 0L41 0C42.1046 0 43 0.895431 43 2V41C43 42.1046 42.1046 43 41 43H2C0.895431 43 0 42.1046 0 41L0 2Z" fill="#35C6F2"/><path d="M24.5 27.5L18.5 21.5L24.5 15.5" stroke="black" stroke-width="2"/></svg></button>',
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        arrows:true,
        nextArrow:'<button class="slick-next custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M43 41C43 42.1046 42.1046 43 41 43L2 43C0.895432 43 0 42.1046 0 41L0 2C0 0.895432 0.895432 0 2 0L41 0C42.1046 0 43 0.895432 43 2L43 41Z" fill="#35C6F2"/><path d="M18.5 15.5L24.5 21.5L18.5 27.5" stroke="black" stroke-width="2"/></svg></button>',
    prevArrow:'<button class="slick-prev custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M0 2C0 0.895431 0.895431 0 2 0L41 0C42.1046 0 43 0.895431 43 2V41C43 42.1046 42.1046 43 41 43H2C0.895431 43 0 42.1046 0 41L0 2Z" fill="#35C6F2"/><path d="M24.5 27.5L18.5 21.5L24.5 15.5" stroke="black" stroke-width="2"/></svg></button>',
        dots: true
      }
    }
  ]
  });
  $('.custom_eliteteam-page .progressbar-slider .elite-image-slider').slick({
    infinite:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    nextArrow:'<button class="slick-next custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M43 41C43 42.1046 42.1046 43 41 43L2 43C0.895432 43 0 42.1046 0 41L0 2C0 0.895432 0.895432 0 2 0L41 0C42.1046 0 43 0.895432 43 2L43 41Z" fill="#35C6F2"/><path d="M18.5 15.5L24.5 21.5L18.5 27.5" stroke="black" stroke-width="2"/></svg></button>',
    prevArrow:'<button class="slick-prev custom_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"><path d="M0 2C0 0.895431 0.895431 0 2 0L41 0C42.1046 0 43 0.895431 43 2V41C43 42.1046 42.1046 43 41 43H2C0.895431 43 0 42.1046 0 41L0 2Z" fill="#35C6F2"/><path d="M24.5 27.5L18.5 21.5L24.5 15.5" stroke="black" stroke-width="2"/></svg></button>',
    swipeToSlide: true,
    dots: false   
  });
  var image_width = $(".custom_eliteteam-page .elite-image-slider .image img").width();

  $(".custom_eliteteam-page .elite-image-slider button.slick-next.custom_arrow.slick-arrow").css("left",image_width);
  
  setTimeout(function(){
  var image_width_2 = $(".custom_eliteteam-page .custom_blocks_slider .main_rpeated_div-wrapp .main_image img").height() / 2;
    $(".custom_eliteteam-page .custom_blocks_slider .main_rpeated_div-wrapp .custom_arrow").css("top",image_width_2);
  },2000);
  
  
}




$(window).on("load resize",function(e){
  
  var screenwidth = $( window ).outerWidth();
	var containerwidth = $('div#multiple-column .page-width').width();
	var calculated = screenwidth - containerwidth;
	var finalval = calculated/2;
	$('.custom_eliteteam-page .page-width.text-with-progress-bar').css('padding-left',finalval+"px");
	
	
  });

document.addEventListener("shopify:section:unload", function(event) {
  maineliteslider();  
});
document.addEventListener("shopify:section:select", function(event) {
  maineliteslider();  
});
document.addEventListener("shopify:section:deselect", function(event) {
  maineliteslider();  
});
document.addEventListener("shopify:section:reorder", function(event) {
  maineliteslider(); 
});
$(document).ready(function() {
  maineliteslider(); 
});
$(window).resize(function() {
  maineliteslider(); 
});



$(document).on("click",".main_post_quiz .take-quiz-msg p.simple-changes-text span.changed_text",function(){
  var header_height = $("header.custom--site-header-sticky").height();
  if ($(window).width() > 768){

    $('html, body').animate({

      scrollTop: $(".main_post_quiz .vector-main-package").offset().top - header_height - 20


    }, 500);
  }
  else{

    $('html, body').animate({

      scrollTop: $(".main_post_quiz .container-custom-tab").offset().top - header_height - 20


    }, 1200);
  }
});

$(document).on("click",".w-big-play-button",function(){
$(".wistia_responsive_wrapper video").trigger("pause");
$(this).parents(".wistia_responsive_wrapper").find("video").trigger("play");
  $(this).parents(".wistia_responsive_wrapper").find("video").prop('muted', false);
});



$.fn.isOnScreen = function() {
  var win = $(window);
  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();
  var bounds = this.offset();
  if(bounds != undefined){
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();
  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  }
};
$(window).scroll(function() {
  $(".slideshow-wrapper .video-section-how-it-work-page").each(function(){
    if ($(this).isOnScreen()) {
      $('.video-section-how-it-work-page.video-section video').trigger('pause');
      $(this).find("video").trigger('play');
    } else {
      $('.video-section-how-it-work-page.video-section video').trigger('pause');
    }
  });
  var iframe = document.getElementById('mainiframvideo');
  $(".slideshow-wrapper .video-section-how-it-work-page").each(function(){
    var player = $f(iframe);
    if ($(this).isOnScreen()) {
      player.api("play");
    } else {
      player.api("pause");
    }
  });
  setTimeout(function(){
    jQuery(".Custom-testimonials-thumbnail-slider").slick("setPosition");
  },100);


});

$(".main_workout_videos.custom_bottom_scroll .main_blogs_tabs_wrapp_main .main_blogs_tabs_wrapp h3.product-tabs-data").click(function() {
$(".main_workout_videos .main_blogs_tabs_wrapp_main .main_blogs_tabs_wrapp .left_side_tabs .product-tabs-data").removeClass("is__active");
var header_height = $("header.custom--site-header-sticky.site-header.site-header--heading-style").height();
  var bar_height = $(".video_page_tabs").height();
$(this).addClass("is__active");
var main_data_handle = $(this).attr("data-url");
$('html, body').animate({
scrollTop: $(".main_workout_videos .main_video_section_wrapp[data-heading='"+main_data_handle+"']").offset().top - header_height - bar_height
}, 1000);
});

var dataUrl = $('.product-tabs-data.is__active').attr('data-url');
$(`.main_workout_videos .main_video_section_wrapp[data-heading='${dataUrl}']`).css('display','block');

$(".main_video_section_wrapp .videos_main_tab a").click(function(){
var sec_id = $(this).parents(".main_video_section_wrapp").attr("data-heading");
  $(".main_video_section_wrapp[data-heading='"+sec_id+"'] .tabs_bottom_content .bottom_tabs").hide();
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp").show();
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .videos_main_tab a").removeClass("is__active");
$(this).addClass("is__active");
// var data_title = $(".workout2-page-wrapp .blog_search_icon-wrapp .search_input input").val().toLowerCase();
var data_title = $(this).text().toLowerCase();;
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp .image_title_wrapp").hide();
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .tabs_bottom_content .bottom_tabs[data_handle='"+data_title+"']").show();
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp .image_title_wrapp").each(function(){
var Each_handle=$.trim($(this).attr("data_handle"));
var data_final = Each_handle.includes(data_title);
if(Each_handle == data_title){
$(this).show();
} 
});

  if(data_title == 'all'){
    $(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp .image_title_wrapp").show();
  }

$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp").each(function(){
var videotag = $(".main_video_section_wrapp[data-heading='"+sec_id+"'].parent_main_wrapp .image_title_wrapp").attr("vid-tag")

var vilength =  $(this).find(".image_title_wrapp:visible").length;
if(vilength == 0){
$(this).hide();
}
else{
$(this).show();
}
});
});


/***** 2-may-2024 PT application tabs js***/
  $(".main_video_section_wrapp .videos_main_tab p").click(function(){
var sec_id = $(this).parents(".main_video_section_wrapp").attr("data-heading");
  $(".main_video_section_wrapp[data-heading='"+sec_id+"'] .tabs_bottom_content .bottom_tabs").hide();
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp").show();
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .videos_main_tab p").removeClass("is__active");
$(this).addClass("is__active");
// var data_title = $(".workout2-page-wrapp .blog_search_icon-wrapp .search_input input").val().toLowerCase();
var data_title = $(this).text().toLowerCase();;
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp .image_title_wrapp").hide();
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .tabs_bottom_content .bottom_tabs[data_handle='"+data_title+"']").show();
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp .image_title_wrapp").each(function(){
var Each_handle=$.trim($(this).attr("data_handle"));
var data_final = Each_handle.includes(data_title);
if(Each_handle == data_title){
$(this).show();
} 
});

  if(data_title == 'all'){
    $(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp .image_title_wrapp").show();
  }


  
$(".main_video_section_wrapp[data-heading='"+sec_id+"'] .parent_main_wrapp").each(function(){
var videotag = $(".main_video_section_wrapp[data-heading='"+sec_id+"'].parent_main_wrapp .image_title_wrapp").attr("vid-tag")

var vilength =  $(this).find(".image_title_wrapp:visible").length;
if(vilength == 0){
$(this).hide();
}
else{
$(this).show();
}
});
});



/***** 2-may ***/

$(".main_page-vid_popup .popup_cross_btn").click(function(){
$(".main_page-vid_popup").hide(); 
$(".main_workout_videos .image_main video").trigger("pause");

});


$(".custom_search_function .blog_search_icon-wrapp .search_input input").keyup(function(){
   $(".main_workout_videos .blank_data_message").hide();
$(".main_video_section_wrapp .parent_main_wrapp").show();
  $(".main_video_section_wrapp").show();
var data_title = $(this).val().toLowerCase();
$(".main_workout_videos .main_blogs_tabs_wrapp .left_side_tabs .product-tabs-data").removeClass("is__active");
if(data_title != ''){    
  $(".main_workout_videos .videos_main_tab_main").hide();
$(".main_workout_videos .image_title_wrapp").hide();
$(".main_workout_videos .image_title_wrapp").each(function(){
       var Each_handle=$.trim($(this).find(".content_wrapp").attr("data-tags"));
var data_final = Each_handle.includes(data_title);
if(data_final){
$(this).show();
}   
   
});
}else{
  $(".main_workout_videos .videos_main_tab_main").show();
$(".main_workout_videos .image_title_wrapp").show(); 
$(".main_video_section_wrapp").each(function(){
var data_head = $(this).attr("data-heading");
$(".main_video_section_wrapp[data-heading='"+data_head+"']").find(".videos_main_tab p").eq(0).trigger("click");
}); 
}

$(".main_video_section_wrapp .parent_main_wrapp").each(function(){
var vilength =  $(this).find(".image_title_wrapp:visible").length;
if(vilength == 0){
$(this).hide();
}
else{
$(this).show();
}
});

$(".main_video_section_wrapp").each(function(){
var vilength =  $(this).find(".parent_main_wrapp:visible").length;
if(vilength == 0){
$(this).hide();
}
else{
$(this).show();
}
});
var data_lenght = $(".main_workout_videos .main_video_section_wrapp:visible").length;
if(data_lenght == 0){
$(".main_workout_videos .blank_data_message").show();
}else{
$(".main_workout_videos .blank_data_message").hide();
}
  
});

$(".pt-video-ctm-wrapp .blog_search_icon-wrapp .search_input input").keyup(function(){
   $(".main_workout_videos .blank_data_message").hide();
$(".main_video_section_wrapp .parent_main_wrapp").show();
  $(".main_video_section_wrapp").show();
var data_title = $(this).val().toLowerCase();
$(".main_workout_videos .main_blogs_tabs_wrapp .left_side_tabs .product-tabs-data").removeClass("is__active");
if(data_title != ''){    
  $(".main_workout_videos .videos_main_tab_main").hide();
$(".main_workout_videos .image_title_wrapp").hide();
$(".main_workout_videos .image_title_wrapp").each(function(){
var Each_handle=$.trim($(this).find(".bottom_content h4").attr("data-text"));
var data_final = Each_handle.includes(data_title);
if(data_final){
$(this).show();
}   
   
});
}else{
  $(".main_workout_videos .videos_main_tab_main").show();
$(".main_workout_videos .image_title_wrapp").show(); 
$(".main_video_section_wrapp").each(function(){
var data_head = $(this).attr("data-heading");
$(".main_video_section_wrapp[data-heading='"+data_head+"']").find(".videos_main_tab p").eq(0).trigger("click");
}); 
}

$(".main_video_section_wrapp .parent_main_wrapp").each(function(){
var vilength =  $(this).find(".image_title_wrapp:visible").length;
if(vilength == 0){
$(this).hide();
}
else{
$(this).show();
}
});

$(".main_video_section_wrapp").each(function(){
var vilength =  $(this).find(".parent_main_wrapp:visible").length;
if(vilength == 0){
$(this).hide();
}
else{
$(this).show();
}
});
var data_lenght = $(".main_workout_videos .main_video_section_wrapp:visible").length;
if(data_lenght == 0){
$(".main_workout_videos .blank_data_message").show();
}else{
$(".main_workout_videos .blank_data_message").hide();
}
  
});

  
  $(window).on("load resize",function(e){
    $(".main_workout_videos .image_title_wrapp").each(function(){
      var blog_image_height =  $(this).find('.image_main').height();
      $(this).find('.bottom_content' ).css({ 'height': 'calc(100% - ' + blog_image_height+ 'px)' }); 
});
var header_height = $("header.custom--site-header-sticky").height();
$(".video_page_tabs").css("top",header_height);
  });

$(document).on("click",".workout2-page-wrapp .main_blogs_tabs_wrapp h3.product-tabs-data",function(e){
  
e.preventDefault();
var showvideo =  $('.video_main_wrapp.parent_main_wrapp').addClass('show_video');
  $(".workout2-page-wrapp .main_blogs_tabs_wrapp h3.product-tabs-data").removeClass("is__active");
  $(this).addClass("is__active");
  $(".workout2-page-wrapp .blog_search_icon-wrapp .search_input input").val('');
  $(".main_workout_videos .blank_data_message").hide();
var custom_main_url = $(this).attr("data-url");
// $(".videos_main_tab_main").show();
$(".main_video_section_wrapp").hide();
$(".main_video_section_wrapp[data-heading='"+custom_main_url+"']").show();
$(".workout2-page-wrapp .main_video_section_wrapp:visible .videos_main_tab p:first-child").trigger("click");

  var tabvalue = $( ".jtpl-tab1-monthly-workout .is__active" ).trigger("click");
});

$(".workout2-page-wrapp .blog_search_icon-wrapp .search_input input").keyup(function(){
 
  var showsvideo =  $('.video_main_wrapp.parent_main_wrapp').removeClass('show_video');
  $(".main_workout_videos .blank_data_message").hide();
 var main_selected_val = $(".main_blogs_tabs_wrapp_main .main_blogs_tabs_wrapp.desktop_search_wrapp h3.product-tabs-data.is__active").attr("data-url");
    $(".main_video_section_wrapp[data-heading='"+main_selected_val+"'] .parent_main_wrapp").show();
   
  $(".main_video_section_wrapp[data-heading='"+main_selected_val+"']").show();
var data_title = $(this).val().toLowerCase();
if(data_title != ''){    
  // $(".main_workout_videos .videos_main_tab_main").hide();
$(".main_workout_videos .image_title_wrapp").hide();
$(".main_workout_videos .main_video_section_wrapp[data-heading='"+main_selected_val+"'] .image_title_wrapp").each(function(){
var Each_handle=$.trim($(this).find(".bottom_content h4").attr("data-text"));
var data_final = Each_handle.includes(data_title);
    if(data_final){
$(this).show();
     
}   
});
}else{
    // $(".videos_main_tab_main").show();
$(".main_blogs_tabs_wrapp_main .main_blogs_tabs_wrapp.desktop_search_wrapp h3.product-tabs-data.is__active") .trigger("click");
}

$(".main_video_section_wrapp .parent_main_wrapp").each(function(){
var vilength =  $(this).find(".image_title_wrapp:visible").length;
if(vilength == 0){
$(this).hide();
}
else{
$(this).show();
}
});

$(".main_video_section_wrapp").each(function(){
var vilength =  $(this).find(".parent_main_wrapp:visible").length;
if(vilength == 0){
$(this).hide();
}
else{
$(this).show();
}
});
var data_lenght = $(".main_workout_videos .main_video_section_wrapp:visible").length;
if(data_lenght == 0){
$(".main_workout_videos .blank_data_message").show();
}else{
$(".main_workout_videos .blank_data_message").hide();
}
  
});
$(".main_workout_videos .video_uper_icon").click(function(){
$(".main_workout_videos .image_main video").trigger("pause");
$(this).parents(".main_workout_videos .image_main").find(".main_page-vid_popup").show();  
$(this).parents(".main_workout_videos .image_main").find(".main_page-vid_popup").addClass("active");  
$(this).parents(".main_workout_videos .image_main").find(".main_page-vid_popup.active video").trigger("play"); 
});
$(function () {
    var maxL = 154;
    $('.main_workout_videos .content_wrapp p').each(function () {
        var text = $(this).text();
        if(text.length > maxL) {
            var begin = text.substr(0, maxL),
                end = text.substr(maxL);
            $(this).html(begin)
                .append($('<a class="readmore"/>').attr('href', '#').html('... read more'))
                .append($('<div class="hidden" />').html(end));
        }
    });
    $(document).on('click', '.main_workout_videos .content_wrapp .readmore', function (e) {
			e.preventDefault();
        $(this).hide();
        $(this).next('.hidden').css("display","inline");
    });
});



$(document).on('click','h3.product-tabs-data',function(){
      var image = $(this).attr('data-attr');
    var mob_image = $(this).attr('data-mobile-image');
  var main_image = $(".catagory-page-banner .desktop_banner").attr('data-image');
  var main_mob_image = $(".catagory-page-banner .mobile_banner").attr('data-mobile-image');
     if( image != ''){
   $('.catagory-page-banner .desktop_banner').attr("src",image);
     $('.catagory-page-banner .mobile_banner').attr("src",mob_image);
     }else{
       $('.catagory-page-banner .desktop_banner').attr("src",main_image);
     $('.catagory-page-banner .mobile_banner').attr("src",main_mob_image);
     }
});

// $(".main_video_section_wrapp .videos_main_tab p").click(function(){
//     var sec_id = $(this).parents(".main_video_section_wrapp").attr("data-heading");
//     $(".main_video_section_wrapp[data-heading='"+sec_id+"'] .tabs_bottom_content .sub-tittle-tab").hide();
//    var data_titles = $(this).text().toLowerCase();
// alert(data_titles);
//    $(".main_video_section_wrapp[data-heading='"+sec_id+"'] .tabs_bottom_content .sub-tittle-tab[subhead_handle='"+data_titles+"']").show();
    
// });

$('.main_blogs_tabs_wrapp .left_side_tabs h3.product-tabs-data.is__active').click(function(){
   $('.main_video_section_wrapp .new-video-with-text .video-jt').show();
   $('.main_video_section_wrapp .new-video-with-text2').show();
    
});

var main_url = window.location.hash;
if(main_url == ""){
} else{
 var main_arr = main_url.split('#')[1];
var main_arr_2 = main_arr.split("--")[0];
var main_arr_3 = main_arr.split("--")[1];
$("h3.product-tabs-data[value='"+main_arr_2+"']").trigger("click");
   setTimeout(function(){
$(".videos_main_tab p[data-value='"+main_arr_3+"']").trigger("click");
  },100);
}


// function filterFunctionality () {
//     setTimeout(function() {
//      // alert('yes');
//      var count ='';
//  var body_region =  $('input[name="body_region"]:checked').val();
//    console.log(body_region);
//  var coach =    $('input[name="coach"]:checked').val();
//   console.log(coach);
//   var duration =   $('input[name="duration"]:checked').val();
//    console.log(duration);
//     var combo = body_region+','+coach+','+duration;
   
//       console.log('check----'+combo);
//     var combo_split =combo.split(',')
//     if(typeof body_region != 'undefined' && typeof coach  != 'undefined' && typeof duration !='undefined'){
//           //console.log(body_region);
//           //console.log(coach);
//           //console.log(duration);
//         $('.parent_main_wrapp .image_title_wrapp.custom_video').hide();
//      var get_slect_val =    $('.videos_main_tab.custom_tags p.is__active').attr('data-value');
//      var  get_slect_val_handle = get_slect_val.replace('-',' ');
//     if(get_slect_val != 'all') {
//     $(`.parent_main_wrapp .image_title_wrapp.custom_video[data_handle="${get_slect_val_handle}"]`).each(function () {
// // $(this).next('span').show();
//    var get_tag = $(this).attr('vid-tag');
//     //console.log(get_tag) ;
//        var spilt_value = get_tag.split(',');
//       //  console.log(spilt_value);
//          console.log(spilt_value[0]);
//       // console.log(spilt_value[1]);
//         //console.log(spilt_value[2]);
// var allExists = combo_split.every(element => spilt_value.includes(element));
//      // console.log(allExists);
//       if(allExists){
//         $(this).show();
//         count++;
//       }
        
//     });
//     } else {
//         $('.parent_main_wrapp .image_title_wrapp.custom_video').each(function () {
//    var get_tag = $(this).attr('vid-tag');
//     //console.log(get_tag) ;
//        var spilt_value = get_tag.split(',');
//       //  console.log(spilt_value);
//          console.log(spilt_value[0]);
//       // console.log(spilt_value[1]);
//         //console.log(spilt_value[2]);
// var allExists = combo_split.every(element => spilt_value.includes(element));
//      // console.log(allExists);
//       if(allExists){
//         $(this).show();
//         count++;
//       }
        
//     });
//     }
//     } 
//       }, 2500);
// }

 function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();      
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
function deleteCookie(name) {
        setCookie({name: name, value: "", seconds: 1});
   var expires = "expires=" + d.toUTCString();      
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }


   function deleteCookie(name) {
     setCookie(name,"",-1);
 }

setTimeout(function(){
console.clear();
},1000);
 
// 21 may 2024
var dialogContainers = [
    { id: "wistia-0k47wy4gnr-2_popover_container", label: "Video_Player" },
    { id: "wistia-0k47wy4gnr-1_popover_container", label: "Video_Player1" },
   // {id:"pKrqgcVNmqUx8tgLuy22",label:"acceptbtn"}

];

dialogContainers.forEach(function(item) {
    var dialogContainer = document.getElementById(item.id);
  if(dialogContainer){
    dialogContainer.setAttribute("aria-label", item.label);
  }
});
//custom add to cart home page
$('.cstmm-tabbtn').click(function(){
    var varinat_idd = $(this).attr('vid');
    $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  dataType: 'json', 
  data: {
    quantity: 1,
    id: varinat_idd
  },
  success: function (data) { 
    $('body').trigger('added.ajaxProduct', this.$addToCart);
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: data
      }
    }));

    jQuery.getJSON('/cart.js', function (cart, textStatus) {
      var gteCartcount = cart.item_count;
      $('span.cart-link__bubble.cart-link__bubble--visible').text(gteCartcount);
    });
  }
});
})






// custom add to cart start 
$('body').on('click', '.cstm-add-quantity.product__quantity .custom_add_to_cart', function() {
   var getId = parseInt($(this).parents('.cstm-add-quantity').attr('data-var-id'));
    var qty = parseInt($(this).parents('.cstm-add-quantity').find('input').val());
    console.log(getId +'=='+qty)
 $.ajax({
type: 'POST',
url: '/cart/add.js',
dataType: 'json',
data: {
quantity: qty,
id: getId
},
dataType: 'json', 
success: function (data) { 
$('body').trigger('added.ajaxProduct', this.$addToCart);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
jQuery.getJSON('/cart.js', function (cart, textStatus) {
var gteCartcount = cart.item_count;
    $('span.cart-link__bubble.cart-link__bubble--visible').text(gteCartcount);
});
} 
});
});

// custom add to cart end


$('.cstm-klaviyo-form-id').click(function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'R6xVLK']);
})

$(document).ready(function() {
    $('.jtpl-meta-colap-content').on('click', function() {
        $('.jtpl_vactor_tabs_heading').each(function() {
            var headingElement = $(this);
            setTimeout(function() {
                var headingText = $.trim(headingElement.find('.jtpl_vactor_tabs_heading1').text());

                if (headingText === '') {
                    headingElement.hide();
                } else {
                    headingElement.show();
                }
            }, 1000);
        });
    });
});










